/* eslint-disable camelcase */
import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
const apiUrl = api_port==='' ? `${protocol}//${hostname}/api` : `${protocol}//${hostname}:${api_port}/api`

const getProviderAuditsAndVerificationsRequested = () => ({
  type: types.GET_PROVIDER_AUDITS_AND_VERIFICATIONS_REQUESTED,
  payload: null
})

const getProviderAuditsAndVerificationsRejected = (error: any) => ({
  type: types.GET_PROVIDER_AUDITS_AND_VERIFICATIONS_REJECTED,
  payload: error
})

const getProviderAuditsAndVerificationsFulfilled = (data: Array<any>) => ({
  type: types.GET_PROVIDER_AUDITS_AND_VERIFICATIONS_FULFILLED,
  payload: data
})

export const getProviderAuditsAndVerifications = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getProviderAuditsAndVerificationsRequested())
    const apiURL = `${apiUrl}/provider/auditsVerifications/${id}`
    request
      .get(apiURL)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getProviderAuditsAndVerificationsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getProviderAuditsAndVerificationsRejected(error))
      })
  }
}

const getBackgroundCheckVerificationByIdRequested = () => ({
  type: types.GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_REQUESTED,
  payload: null
})

const getBackgroundCheckVerificationByIdFulfilled = (data: any) => ({
  type: types.GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_FULFILLED,
  payload: data
})

const getBackgroundCheckVerificationByIdRejected = (error: any) => ({
  type: types.GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_REJECTED,
  payload: error
})

export const getBackgroundCheckVerificationById = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getBackgroundCheckVerificationByIdRequested())
    request
      .get(`${apiUrl}/backgroundCheckVerification/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getBackgroundCheckVerificationByIdFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getBackgroundCheckVerificationByIdRejected(error))
      })
  }
}

const updateBackgroundCheckVerificationRequested = () => ({
  type: types.UPDATE_BACKGROUND_CHECK_VERIFICATION_REQUESTED,
  payload: null
})

const updateBackgroundCheckVerificationFulfilled = (data) => ({
  type: types.UPDATE_BACKGROUND_CHECK_VERIFICATION_FULFILLED,
  payload: data
})

const updateBackgroundCheckVerificationRejected = (error) => ({
  type: types.UPDATE_BACKGROUND_CHECK_VERIFICATION_REJECTED,
  payload: error
})

export const updateBackgroundCheckVerification = (backgroundCheck: any, id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(updateBackgroundCheckVerificationRequested())
    request
      .put(`${apiUrl}/backgroundCheckVerification/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .send(backgroundCheck)
      .then((response) => {
        dispatch(updateBackgroundCheckVerificationFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateBackgroundCheckVerificationRejected(error))
      })
  }
}

export const uploadedBackgroundCheckVerificationAttachment = (data: {backgroundCheckVerificationEmployeeId: number; attachmentType: string; fileLocation: string; enteredDate: string; background_check_verification_employee_attachment_id: number; backgroundCheckVerificationId: number}) => ({
  type: types.UPLOADED_BACKGROUND_CHECK_VERIFICATION_ATTACHMENT,
  payload: data
})

const getServiceVerificationAuditByIdRequested = () => ({
  type: types.GET_SERVICE_VERIFICATION_AUDIT_BY_ID_REQUESTED,
  payload: null
})

const getServiceVerificationAuditByIdFulfilled = (data: any) => ({
  type: types.GET_SERVICE_VERIFICATION_AUDIT_BY_ID_FULFILLED,
  payload: data
})

const getServiceVerificationAuditByIdRejected = (error: any) => ({
  type: types.GET_SERVICE_VERIFICATION_AUDIT_BY_ID_REJECTED,
  payload: error
})

export const getServiceVerificationAuditById = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getServiceVerificationAuditByIdRequested())
    request
      .get(`${apiUrl}/serviceVerificationAudit/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getServiceVerificationAuditByIdFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getServiceVerificationAuditByIdRejected(error))
      })
  }
}

const updateServiceVerificationAuditRequested = () => ({
  type: types.UPDATE_SERVICE_VERIFICATION_AUDIT_REQUESTED,
  payload: null
})

const updateServiceVerificationAuditFulfilled = (data) => ({
  type: types.UPDATE_SERVICE_VERIFICATION_AUDIT_FULFILLED,
  payload: data
})

const updateServiceVerificationAuditRejected = (error) => ({
  type: types.UPDATE_SERVICE_VERIFICATION_AUDIT_REJECTED,
  payload: error
})

export const updateServiceVerificationAudit = (serviceVerification: any, id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(updateServiceVerificationAuditRequested())
    request
      .put(`${apiUrl}/serviceVerificationAudit/${id}`)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .send(serviceVerification)
      .then((response) => {
        dispatch(updateServiceVerificationAuditFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateServiceVerificationAuditRejected(error))
      })
  }
}